import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./root.reducer";
import { agroApi } from "shared/api/agroApi";

declare const process: any;
const isDevelopmentMode = process.env.NODE_ENV === "development";

const rootStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(agroApi.middleware),
  devTools: isDevelopmentMode,
});

export type AppDispatch = typeof rootStore.dispatch;

export { rootStore };
